import { SVGProps } from "react";

const EmptyNote = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={64}
    height={63}
    viewBox="0 0 64 63"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24.125 9.875C24.125 8.77043 25.0204 7.875 26.125 7.875H37.875C38.9796 7.875 39.875 8.77043 39.875 9.875V18.375H24.125V9.875Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.125 13.125H15.625C14.5204 13.125 13.625 14.0204 13.625 15.125V53.125C13.625 54.2296 14.5204 55.125 15.625 55.125H26.75M39.875 13.125H48.375C49.4796 13.125 50.375 14.0204 50.375 15.125V31.5"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M37.25 42L43.8125 48.5625M50.375 55.125L43.8125 48.5625M43.8125 48.5625L50.375 42M43.8125 48.5625L37.25 55.125"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default EmptyNote;
